module.exports = "/images/intercard.svg?aba849077e001a9080d3115c36a697bf";